<section class="section-panel" [attr.aria-label]="ariaLabel || heading">
  <header class="section-panel-header">
    <h3>{{ heading }}</h3>
    <div class="section-panel-actions"><ng-content select="[panel-actions]"></ng-content></div>
  </header>
  <div class="section-panel-content"><ng-content></ng-content></div>
  <div *ngIf="empty" class="section-panel-empty"><ng-content select="[panel-empty]"></ng-content></div>
</section>